<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Review {{ item?.ZI_C_COMPANY_NAME }}</p>
        </header>
        <section class="modal-card-body">
            <loading v-if="loading"></loading>
            <div class="columns is-multiline" v-else>
                <div class="column is-6">
                    <info-line label="Parent" :value="item?.ZI_C_IMMEDIATE_PARENT_NAME ? item?.ZI_C_IMMEDIATE_PARENT_NAME : 'This is the parent company'"></info-line>
                    <info-line label="Employees" :value="$filters.AddCommas(item?.ZI_C_EMPLOYEES)"></info-line>
                    <info-line label="Employee growth" :value="$filters.Percentage(item?.ZI_C_EMPLOYEE_GROWTH_2YR, 1)"></info-line>
                    <br />
                    <info-line label="Industries">
                        <div v-for="(industry, i) in industries" :key="i">
                            {{ industry }}
                        </div>
                    </info-line>
                    <br />
                    <info-line label="Ticker symbol" :value="item?.ZI_C_TICKER || item?.ZI_C_TICKERS_ALT || 'Not available'"></info-line>
                    <info-line label="Revenue range" :value="item?.ZI_C_COMPANY_REVENUE_RANGE"></info-line>
                    <info-line label="Funding amount" v-if="item.ZI_C_LATEST_FUNDING_AMOUNT" :value="$filters.FormatK('$', item.ZI_C_LATEST_FUNDING_AMOUNT)"></info-line>
                    <info-line label="Funding date" v-if="item.ZI_C_LATEST_FUNDING_DATE" :value="$filters.Date(item.ZI_C_LATEST_FUNDING_DATE)"></info-line>
                </div>
                <div class="column is-6">
                    <info-line label="Address" :loading="loading" v-if="item.ZI_C_STREET" :value="item.ZI_C_STREET"></info-line>
                    <info-line label="City" :loading="loading" v-if="item.ZI_C_CITY" :value="item.ZI_C_CITY"></info-line>
                    <info-line label="State" :loading="loading" v-if="item.ZI_C_STATE" :value="item.ZI_C_STATE"></info-line>
                    <info-line label="Zip Code" :loading="loading" v-if="item.ZI_C_ZIP" :value="item.ZI_C_ZIP"></info-line>
                    <info-line label="Country" :loading="loading" v-if="item.ZI_C_COUNTRY" :value="item.ZI_C_COUNTRY"></info-line>
                    <br />
                    <info-line label="Web address">
                        <a :href="FixLink(item.ZI_C_COMPANY_URL)" v-if="!isframe">{{item.ZI_C_COMPANY_URL}}</a>
                        <span v-else>{{item.ZI_C_COMPANY_URL}}</span>
                    </info-line>
                    <info-line label="Facebook" v-if="item?.ZI_C_FACEBOOK_URL">
                        <a :href="FixLink(item?.ZI_C_FACEBOOK_URL)" target="_blank" v-if="!isframe">Facebook <o-icon icon="external-link"></o-icon></a>
                        <span v-else>
                            <o-icon icon="check" v-if="item.ZI_C_FACEBOOK_URL"></o-icon>
                            <o-icon icon="times" v-else></o-icon>
                        </span>
                    </info-line>
                    <info-line label="LinkedIn" v-if="item?.ZI_C_LINKEDIN_URL">
                        <a :href="FixLink(item?.ZI_C_LINKEDIN_URL)" target="_blank" v-if="!isframe">LinkedIn <o-icon icon="external-link"></o-icon></a>
                        <span v-else>
                            <o-icon icon="check" v-if="item.ZI_C_LINKEDIN_URL"></o-icon>
                            <o-icon icon="times" v-else></o-icon>
                        </span>
                    </info-line>
                    <info-line label="Twitter" v-if="item?.ZI_C_TWITTER_URL">
                        <a :href="FixLink(item?.ZI_C_TWITTER_URL)" target="_blank" v-if="!isframe">Twitter <o-icon icon="external-link"></o-icon></a>
                        <span v-else>
                            <o-icon icon="check" v-if="item.ZI_C_TWITTER_URL"></o-icon>
                            <o-icon icon="times" v-else></o-icon>
                        </span>
                    </info-line>
                    <br />
                    <info-line label="ZoomInfo page">
                        <a :href="item?.ZoomInfoUrl" target="_blank" v-if="!isframe">View</a>
                        <span v-else>{{item.ZoomInfoUrl}}</span>
                    </info-line>

                    <div class="columns mt-4" v-if="inveniasId">
                        <div class="column is-6">
                            <o-checkbox v-model="isClient">Is Client?</o-checkbox>
                        </div>
                        <div class="column is-6">
                            Client status
                            <o-field>
                                <o-radio v-model="clientStatus" name="clientStatus" native-value="979ac2f0-74e0-ea11-9b05-0003ff205a8d" :disabled="!isClient">Prospect</o-radio>
                            </o-field>
                            <o-field>
                                <o-radio v-model="clientStatus" name="clientStatus" native-value="969ac2f0-74e0-ea11-9b05-0003ff205a8d" :disabled="!isClient">Current</o-radio>
                            </o-field>
                            <o-field>
                                <o-radio v-model="clientStatus" name="clientStatus" native-value="989ac2f0-74e0-ea11-9b05-0003ff205a8d" :disabled="!isClient">Previous</o-radio>
                            </o-field>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot is-justify-content-space-between">
            <div>
                <o-button variant="light" @click="Close">Return to results</o-button>
            </div>
            <div>
                <o-button variant="primary" :disabled="loading" @click="Next">
                    Enrich
                </o-button>
            </div>
        </footer>
    </div>
</template>
<script>
    import infoLine from "@/components/webComponents/infoLine.vue";
    import { ref, computed, inject, onMounted } from "vue";

    export default {
        components: {
            infoLine
        },
        props: {
            companyId: {
                type: Number,
                default: 0
            },
            itemId: {
                type: Number,
                default: 0
            },
            type: {
                type: String,
                default: "mcl"
            },
            inveniasId: {
                type: String,
                default: null
            }
        },
        emits: ["onLinked", "close"],
        setup(props, context) {
            const http = inject("$http");
            const confirm = inject("$confirm");
            const isframe = inject("$isFrame");

            const loading = ref(true);
            const isClient = ref(false);
            const clientStatus = ref();
            const item = ref({});

            const industries = computed(() => {
                if (item.value?.ZI_C_INDUSTRIES) {
                    try {
                        return JSON.parse(item.value?.ZI_C_INDUSTRIES);
                    }
                    catch (err) { return item.value?.ZI_C_INDUSTRIES.split('|'); }
                }
                else return [];
            })

            const FixLink = (url) => {
                if (url) {
                    if (url.startsWith("http://") || url.startsWith("https://")) return url;
                    else {
                        url = "https://" + url;
                        return url;
                    }
                }
                else return "#";
            }

            const GetEnrichment = async () => {
                loading.value = true;

                try {
                    const resp = await http.get("/api/v2/company/zoominfo/" + props.itemId + "/enrich");
                    item.value = resp.data;
                }
                catch (err) {
                    console.error(err);
                }

                loading.value = false;
            }

            const LinkToEnrichment = async () => {
                if (props.type == "mcl") {
                    try { //companyId is an Mcl Id
                        await http.get("/api/v2/company/" + props.companyId + "/zoominfo/" + props.itemId + "/link");
                    }
                    catch (err) {
                        console.error(err);
                    }
                }
                else if (props.type == "invenias") {
                    try { //companyId is an Invenias Id
                        await http.get("/api/v2/company/invenias/" + props.inveniasId + "/zoominfo/" + props.itemId + "/link");
                    }
                    catch (err) {
                        console.error(err);
                    }
                }
            }

            const TryUpdateInvenias = async () => {
                if (props.inveniasId) {
                    try {
                        await http.post("/api/v2/company/" + props.companyId + "/invenias/" + props.inveniasId + "/updateClientStatus",
                            {
                                isClient: isClient.value,
                                clientStatus: clientStatus.value
                            });
                    }
                    catch (err) {
                        console.error(err);
                    }
                }
            }

            const Close = () => {
                context.emit("close");
            };

            const Next = () => {
                confirm({
                    title: "Are you sure?",
                    message: "This company will be updated with this ZoomInfo data, some previously entered data may be overwritten.",
                    cancelText: "Return to search",
                    confirmText: "Proceed",
                    onConfirm: async () => {
                        loading.value = true;
                        await LinkToEnrichment();
                        await TryUpdateInvenias();
                        Close();
                        context.emit("onLinked", { zoominfoId: props.itemId });
                    }
                });

            }

            onMounted(() => {
                GetEnrichment();
            })

            return {
                isframe,
                loading,
                clientStatus,
                isClient,
                item,
                industries,
                FixLink,
                Close,
                Next
            };
        }
    };
</script>
